import api from '@/services/Api';
import { Package } from '@/models/repairModule/Package'

class PackageService {
  async getPackage(repairFileBoomerangId) {
    const url = '/distributor/get-package-by-repair-file-boomerang-id/' + repairFileBoomerangId
    const response = await api.get(url)

    return new Package(
      response.data.technical_id,
      response.data.boomerang_id,
      response.data.package_type,
      response.data.client_price,
      response.data.network_code,
      response.data.display_estimate
    )
  }
}

export default new PackageService()
